import { createRoot } from 'react-dom/client'
import { createInertiaApp } from '@inertiajs/react'

// Initialize carousel functionality for GrapesJS content
import '@/lib/carousel-init'

createInertiaApp({
  resolve: (name) => {
    // Exclude test files from page resolution
    const pages = import.meta.glob(['../pages/**/*.tsx', '!../pages/**/__tests__/**', '!../pages/**/*.test.tsx'], { eager: true })
    const page = pages[`../pages/${name}.tsx`]
    if (!page) {
      throw new Error(`Page not found: ${name}`)
    }
    return page
  },
  setup({ el, App, props }) {
    createRoot(el).render(<App {...props} />)
  },
})
